import script from "./ProjectReviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectReviewCard.vue?vue&type=script&setup=true&lang=js"

import "./ProjectReviewCard.vue?vue&type=style&index=0&id=13bab102&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13bab102"]])

export default __exports__